import React from 'react';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';

const CostBreakdownTooltip = ({ t, idValue, shippingCost, surplusCharge, total, displayIcon = false }) => {
	return (
		<React.Fragment>
			<ReactTooltip className="surcharge" id={`$surchargeTooltip-${idValue}`}>
				<div className="item">
					<span>{t('TOOLTIP.SHIPPINGCOST.COST')}</span>
					<span>{shippingCost}</span>
				</div>
				<div className="item">
					<span>{t('TOOLTIP.SHIPPINGCOST.SURPLUS')}</span>
					<span>{surplusCharge}</span>
				</div>
				<div className="item total">
					<span>{t('TOOLTIP.SHIPPINGCOST.TOTAL')}</span>
					<span>{`$${total}`}</span>
				</div>
			</ReactTooltip>
			{displayIcon && (
				<i
					data-for={`$surchargeTooltip-${idValue}`}
					data-tip=""
					className="fa fa-info-circle spc--left--tny flex--grow--1"
				></i>
			)}
		</React.Fragment>
	);
};

export default defaultTemplate(CostBreakdownTooltip);



// WEBPACK FOOTER //
// ./src/common/tooltips/CostBreakdownTooltip.jsx